export const ROLES = {
  RESOURCE_MANAGER: "Resource Manager/PMO",
  ENGAGEMENT_MANAGER: "Engagement Manager",
  GLOBAL_REPORTING: "Global Level Reporting User",
  SUPER_REGIONAL_REPORTING: "Super Regional Level Reporting User",
  REGIONAL_REPORTING: "Regional Level Reporting User",
  COUNTRY_REPORTING: "Country Level Reporting User",
};

export function normalizeRoles(role) {
  if (Array.isArray(role)) {
    return role.filter((r) => typeof r === "string" && r.trim().length > 0);
  }
  if (typeof role === "string" && role.trim().length > 0) {
    return [role];
  }
  return [];
}

function toLowerList(roles) {
  return normalizeRoles(roles).map((r) => r.toLowerCase());
}

export function hasRole(roles, target) {
  if (!target) return false;
  const list = toLowerList(roles);
  return list.includes(String(target).toLowerCase());
}

export function hasRoleIncluding(roles, substring) {
  if (!substring) return false;
  const needle = String(substring).toLowerCase();
  return toLowerList(roles).some((r) => r.includes(needle));
}

export function isResourceManager(roles) {
  return hasRoleIncluding(roles, "resource");
}

export function isEngagementManager(roles) {
  return hasRoleIncluding(roles, "engagement");
}

export function isGlobalReporting(roles) {
  return hasRoleIncluding(roles, "global");
}

export function isSuperRegionalReporting(roles) {
  return hasRoleIncluding(roles, "super regional");
}

export function isRegionalReporting(roles) {
  const list = toLowerList(roles);
  return list.some(
    (r) => r.includes("regional") && !r.includes("super regional"),
  );
}

export function isCountryReporting(roles) {
  return hasRoleIncluding(roles, "country");
}

export function isReportingUser(roles) {
  return (
    isGlobalReporting(roles) ||
    isSuperRegionalReporting(roles) ||
    isRegionalReporting(roles) ||
    isCountryReporting(roles)
  );
}

export function hasAnyReportingRole(roles) {
  return isReportingUser(roles);
}

export function hasUserManagementAccess(roles) {
  return isResourceManager(roles);
}

export function isGdsEmail(email) {
  if (typeof email !== "string") return false;
  const at = email.lastIndexOf("@");
  if (at === -1) return false;
  const domain = email.slice(at + 1).toLowerCase().trim();
  return domain.split(".").includes("gds");
}
